import { useEffect, useState } from "react";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

/** Masks configured credentials without loading them; explicit eye actions reveal only in memory. */
export default function GatewayCredentialField({ label, value, configured, storedValue, onReveal, onChange, busy, disabled, maxLength = 512 }) {
  const [showDraft, setShowDraft] = useState(false);
  useEffect(() => { if (!value) setShowDraft(false); }, [value]);
  useEffect(() => {
    if (!showDraft) return;
    const timer = setTimeout(() => setShowDraft(false), 60000);
    return () => clearTimeout(timer);
  }, [showDraft]);
  const storedVisible = storedValue !== undefined;
  const visible = value ? showDraft : storedVisible;
  return <TextField className="dk-gateway-credential" fullWidth type={visible ? "text" : "password"} autoComplete="new-password" label={label}
    value={value || (storedVisible ? storedValue : "")} placeholder={configured ? "********" : ""} disabled={disabled}
    InputLabelProps={{ shrink: configured ? true : undefined }}
    onChange={(event) => onChange(event.target.value)} inputProps={{ maxLength, dir: "ltr" }}
    helperText={configured ? "تنظیم شده؛ برای حفظ مقدار قبلی، کادر را خالی بگذارید." : "تنظیم نشده است."}
    InputProps={{ readOnly: !value && storedVisible, endAdornment: <InputAdornment position="end">
      <IconButton type="button" aria-label={`${visible ? "پنهان کردن" : "نمایش"} ${label}`} aria-pressed={visible}
        disabled={disabled || busy || (!value && !configured)} onClick={() => value ? setShowDraft((shown) => !shown) : onReveal()}>
        {visible ? <VisibilityOff /> : <Visibility />}
      </IconButton>
    </InputAdornment> }} />;
}
